import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import React from 'react';
import './App.css';

import Navbar from './components/Navbar';
import Education from './pages/Education';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Interests from './pages/Interests';
import Projects from './pages/Projects';

import AGoodAlien from './pages/AGoodAlien';
import KingsPath from './pages/KingsPath';
import BalloonsOdyssey from './pages/BalloonsOdyssey';

import BalloonsOdyssey_Skin01 from './pages/BalloonsOdyssey_Skin01';
import BalloonsOdyssey_Skin02 from './pages/BalloonsOdyssey_Skin02';
import BalloonsOdyssey_Skin03 from './pages/BalloonsOdyssey_Skin03';

import BalloonsOdyssey_Advertisement from './pages/BalloonsOdyssey_Advertisement';
import BalloonsOdyssey_Settings from './pages/BalloonsOdyssey_Settings';
import BalloonsOdyssey_Tournament from './pages/BalloonsOdyssey_Tournament';

import BalloonsOdyssey_WorldGUI from './pages/BalloonsOdyssey_WorldGUI';
import BalloonsOdyssey_World01 from './pages/BalloonsOdyssey_World01';
import BalloonsOdyssey_World02 from './pages/BalloonsOdyssey_World02';
import BalloonsOdyssey_World03 from './pages/BalloonsOdyssey_World03';
import BalloonsOdyssey_World04 from './pages/BalloonsOdyssey_World04';
import BalloonsOdyssey_World05 from './pages/BalloonsOdyssey_World05';

import BalloonsOdyssey_Store01 from './pages/BalloonsOdyssey_Store01';
import BalloonsOdyssey_Store02  from './pages/BalloonsOdyssey_Store02';
import BalloonsOdyssey_Store03  from './pages/BalloonsOdyssey_Store03';
import BalloonsOdyssey_Store04  from './pages/BalloonsOdyssey_Store04';
import BalloonsOdyssey_Store05  from './pages/BalloonsOdyssey_Store05';


function App() {
  return (
    <>
      <Router>
        <Navbar />
        <Routes>
          {/* Navigation Bar routes. */}
          <Route path='/contact' element = {<Contact/>} />
          <Route path='/education' element = {<Education/>} />
          <Route path='/' element = {<Home/>} />
          <Route path='/interests' element = {<Interests/>} />
          <Route path='/projects' element = {<Projects/>} />

          {/* Cards routes. */}
          <Route path='/agoodalien' element = {<AGoodAlien/>} />
          <Route path='/kingspath' element = {<KingsPath/>} />
          <Route path='/balloonsodyssey' element = {<BalloonsOdyssey/>} />

          <Route path='/balloonsodyssey-advertisement' element = {<BalloonsOdyssey_Advertisement/>} />
          <Route path='/balloonsodyssey-settings' element = {<BalloonsOdyssey_Settings/>} />
          <Route path='/balloonsodyssey-tournament' element = {<BalloonsOdyssey_Tournament/>} />
          <Route path='/balloonsodyssey-worldGUI' element = {<BalloonsOdyssey_WorldGUI/>} />

          <Route path='/balloonsodyssey-travelerskin' element = {<BalloonsOdyssey_Skin01/>} />
          <Route path='/balloonsodyssey-betaskin' element = {<BalloonsOdyssey_Skin02/>} />
          <Route path='/balloonsodyssey-wizardskin' element = {<BalloonsOdyssey_Skin03/>} />

          <Route path='/balloonsodyssey-world01' element = {<BalloonsOdyssey_World01/>} />
          <Route path='/balloonsodyssey-world02' element = {<BalloonsOdyssey_World02/>} />
          <Route path='/balloonsodyssey-world03' element = {<BalloonsOdyssey_World03/>} />
          <Route path='/balloonsodyssey-world04' element = {<BalloonsOdyssey_World04/>} />
          <Route path='/balloonsodyssey-world05' element = {<BalloonsOdyssey_World05/>} />

          <Route path='/balloonsodyssey-store01' element = {<BalloonsOdyssey_Store01/>} />
          <Route path='/balloonsodyssey-store02' element = {<BalloonsOdyssey_Store02/>} />
          <Route path='/balloonsodyssey-store03' element = {<BalloonsOdyssey_Store03/>} />
          <Route path='/balloonsodyssey-store04' element = {<BalloonsOdyssey_Store04/>} />
          <Route path='/balloonsodyssey-store05' element = {<BalloonsOdyssey_Store05/>} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
